<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('setpwd.modifyLoginPassword') }}
      </div>
    </div>
    <div class="wrap">
      <div class="write_box">
        <input
          v-model="password"
          :type="passwordInp"
          :placeholder="$t('setpwd.originalloginpassword')"
        >
        <div
          class="eye_bi"
          :class="passwordInp=='text'?'eye':''"
          @click="showPwd"
        />
      </div>
      <div class="write_new_pwd">
        <div class="write_box">
          <input
            v-model="npassword"
            :type="newpasswordInp"
            :placeholder="$t('setpwd.newpassword')"
          >
          <div
            class="eye_bi"
            :class="newpasswordInp=='text'?'eye':''"
            @click="showNewsPwd"
          />
        </div>
        <div class="write_box">
          <input
            v-model="rpassword"
            :type="newpasswordInp"
            :placeholder="$t('setpwd.confirmnewpassword')"
          >
          <div
            class="eye_bi"
            :class="newpasswordInp=='text'?'eye':''"
            @click="showNewsPwd"
          />
        </div>
      </div>
        
      <div
        v-if="codeStatus"
        class="basic_btn"
        :class="rpassword!=''&&code!=''&&npassword!=''?'':'no_touch'"
        @click="dxRevise"
      >
        {{ $t('setpwd.modify') }}
      </div>
      <div
        v-if="!codeStatus"
        class="basic_btn"
        :class="password!=''&&rpassword!=''&&npassword!=''? '':'no_touch'"
        @click="oldRevise"
      >
        {{ $t('setpwd.modify') }}
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import {
        CountDown,
    } from 'vant';
    import Fetch from '../../utils/fetch'

    Vue.use(CountDown);

    export default {
        name: "Setpwd",
        data() {
            return {
                time: 0,
                oldpwd: '',
                password: '',
                rpassword: '',
                npassword: '',
                mobile: '',
                ycmobile: '',
                passwordInp: 'password',
                newpasswordInp: 'password',
                codeStatus: false,
                codeOK: false,
                code: '',
                is_send: false
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            Fetch('/user/info').then(r => {
                this.mobile = r.data.mobile;
                this.ycmobile = r.data.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
            })
        },
        methods: {
            cutType(n) {
                n == 1 ? this.codeStatus = true : this.codeStatus = false;
                this.rpassword = '';
                this.npassword = '';
            },
            timeCall() {
                this.is_send = false;
                this.time = 0;
            },
            sendcode() {
                if (this.is_send) {
                    return;
                }
                this.is_send = true;
                Fetch("/index/forgetpwd_email_code", {
                }).then(() => {
                    this.time = 120 * 1000;
                    this.$toast({
                        background: '#07c160',
                        message: this.$t('setpwd.sendsuccessfully')
                    });
                }).catch(() => {
                    this.is_send = false;
                });

            },
            showPwd() {
                this.passwordInp == 'password' ? this.passwordInp = 'text' : this.passwordInp = 'password'
            },
            showNewsPwd() {
                this.newpasswordInp == 'password' ? this.newpasswordInp = 'text' : this.newpasswordInp = 'password'
            },
            dxRevise() {

                if (!this.npassword) {
                    this.$toast(this.$t('setpwd.newpasswordcannotbeempty'));
                    return false;
                }

                if (this.npassword !== this.rpassword) {
                    this.$toast(this.$t('setpwd.inconsistent'));
                    return false;
                }

                Fetch('/index/forgetpwd', {
                    code: this.code,
                    password: this.npassword,
                }).then(() => {

                    this.$toast({
                        background: '#07c160',
                        message: this.$t('setpwd.modifiedsuccessfully')
                    });

                    this.$router.replace('/set')
                });

            },
            oldRevise() {
                if (!this.password) {
                    this.$toast(this.$t('setpwd.originalpasswordcannotbeempty'));
                    return false;
                }
                if (!this.npassword) {
                    this.$toast(this.$t('setpwd.newpasswordcannotbeempty'));
                    return false;
                }
                if (this.npassword !== this.rpassword) {
                    this.$toast(this.$t('setpwd.inconsistent'));
                    return false;
                }
                Fetch('/user/repasswd', {
                    passwd: this.password,
                    npasswd: this.npassword,
                }).then(() => {
                    this.$toast({
                        background: '#07c160',
                        message: this.$t('setpwd.modifiedsuccessfully')
                    });
                    this.$router.replace('/set')
                });
            },
        }
    };
</script>

<style lang="less" scoped>
	
    .no_touch {
        pointer-events: none;
    }

    .wrap {
        padding: 0px 20px 0 20px;
    }

    .title {
        width: 100%;
        height: 25px;
        line-height: 25px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
            font-size: 18px;
            color: #0063d2;
            font-weight: 400;
        }

        .cut {
            font-size: 12px;
            color: #3D96FF;
        }
    }

    .bd_tel {
        margin-top: 23px;
        color: #0063d2;
        font-size: 14px;
        font-weight: 400;
    }

    .inp_box {
        display: flex;
        justify-content: space-between;
        height: 45px;
        margin-top: 9px;

        .inp {
            width: 195px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 10px;
            border-radius: 2px;
            background-color: #FFFFFF;

            input {
                width: 100%;
                height: 22px;
                line-height: 22px;
                font-size: 16px;
            }
        }

        .getcode {
            flex: 1;
            margin-left: 10px;
            font-size: 16px;
            text-align: center;
            line-height: 45px;
            height: 45px;
            border-radius: 8px;
        }

        .reset_code {
            background: rgba(228, 228, 228, 1);
            color: rgba(0, 0, 0, 0.3);
        }
    }

    .write_box {
        width: 100%;
        height: 45px;
        margin-top: 32px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        border-radius: 2px;
        background-color: #FFFFFF;

        input {
            width: 100%;
            height: 22px;
            line-height: 22px;
            font-size: 16px;
        }
    }

    .eye_bi {
        width: 21px;
        height: 25px;
        background: url(../images/user/eye2.png) no-repeat center center;
        background-size: 100% auto;

        &.eye {
            background: url(../images/user/eye1.png) no-repeat center center;
            background-size: 100% auto;
        }
    }

    .basic_btn {
        margin: 43px auto 0 auto;
    }

    .write_new_pwd {
        margin-top: 32px;

        .write_box:first-child {
            margin-bottom: 18px;
            margin-top: 0px;
        }

        .write_box:last-child {
            margin-top: 0px;
        }
    }
	.red_top_bg {
		// background: linear-gradient(90deg, #5b60df, #5b60df) !important;
	}

	/* Scoped password form styling. */
	.basic_wrap { min-height: 100vh; padding-bottom: calc(86px + env(safe-area-inset-bottom)); background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5); }.red_top_bg { height: 54px; background: rgba(255, 252, 245, .97); border-bottom: 1px solid rgba(190, 139, 52, .45); }.red_top_bg .big_tit, .red_top_bg .back_left { color: #873126; }
	.wrap { padding: 2px 18px 0; }.write_box { height: 50px; margin-top: 22px; padding: 0 13px; border-color: rgba(190, 139, 52, .46); border-radius: 10px; background: #fffdf8; box-shadow: 0 4px 12px rgba(125, 82, 35, .06); }.write_box input { color: #533126; }.write_box input::placeholder { color: #a57b62; }.write_new_pwd { margin-top: 18px; }.basic_btn { height: 50px; margin-top: 34px; border: 1px solid rgba(166, 35, 61, .42); border-radius: 12px; background: linear-gradient(105deg, #a6233d, #ca5a5b) !important; color: #fff8e8 !important; line-height: 48px; box-shadow: 0 9px 20px rgba(126, 28, 47, .2); }.basic_btn.no_touch { opacity: .42; }
</style>
